import { render, staticRenderFns } from "./psychological.vue?vue&type=template&id=2efb9911&scoped=true"
import script from "./psychological.vue?vue&type=script&lang=js"
export * from "./psychological.vue?vue&type=script&lang=js"
import style0 from "./psychological.vue?vue&type=style&index=0&id=2efb9911&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb9911",
  null
  
)

export default component.exports